import React, { useState, useEffect, useRef } from 'react';
import Card from '../../components/Card';
import CreateCard from '../../components/forms/CreateCard';
import { useUser } from '../../contexts/userContext';
import { useCard } from '../../contexts/cardContext';
import { useColumns } from '../../contexts/columnsContext';
import { Droppable } from 'react-beautiful-dnd';
import './style.css';

import { MdInfo } from "react-icons/md";

function Column(props) {
  const { columnCards, columnSummaries, loadMoreColumnCards, kanbanReady } = useCard();
  const [loadingMore, setLoadingMore] = useState(false);

  const { getAccessLevel } = useUser();


  const { orderBy, isAscending, filteredColumns } = useColumns();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const columnBodyRef = useRef(null);

  const handleAddCardClick = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  const [isModalOpenInfoColumn, setIsModalOpenInfoColumn] = useState(false);


  // Cards já vêm filtrados e ordenados do servidor
  const colData = columnCards[props.columnData.id];
  const cardsToRender = colData?.cards || [];

  // Summary data from server (total count across all pages, total value)
  const summary = columnSummaries.find(s => s.column_id === props.columnData.id);
  const cardCount = summary ? parseInt(summary.count, 10) : cardsToRender.length;
  const totalCostValue = summary ? parseFloat(summary.total_value || 0) : cardsToRender.reduce((acc, card) => acc + parseFloat(card.cost_value || 0), 0);

  // Infinite scroll — load more pages from server
  const loadingMoreRef = useRef(false);

  useEffect(() => {
    const handleScroll = async () => {
      if (!columnBodyRef.current || loadingMoreRef.current) return;
      const { scrollTop, clientHeight, scrollHeight } = columnBodyRef.current;
      if (scrollTop + clientHeight >= scrollHeight - 10) {
        if (colData?.hasMore) {
          loadingMoreRef.current = true;
          setLoadingMore(true);
          await loadMoreColumnCards(props.columnData.id);
          setLoadingMore(false);
          loadingMoreRef.current = false;
        }
      }
    };

    const columnBodyElement = columnBodyRef.current;
    if (columnBodyElement) {
      columnBodyElement.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (columnBodyElement) {
        columnBodyElement.removeEventListener('scroll', handleScroll);
      }
    };
  }, [colData, props.columnData.id, loadMoreColumnCards]);



  const [tooltip, setTooltip] = useState({ visible: false, x: 0, y: 0, text: '' });

  const showTooltip = (e, text) => {
    const rect = e.target.getBoundingClientRect(); // Obtem a posição do botão na tela
    setTooltip({
      visible: true,
      x: rect.left + rect.width / 2, // Centraliza no botão
      y: rect.top - 10, // Posiciona acima do botão
      text,
    });
  };

  const hideTooltip = () => {
    setTooltip({ visible: false, x: 0, y: 0, text: '' }); // Oculta a tooltip
  };




  return (
    <Droppable droppableId={String(props.columnData.id)}>
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.droppableProps}
          style={{
            backgroundColor: snapshot.isDraggingOver ? '#c8f3bf' : '#F0F2F5',
          }}
          className='column-container2'
        >
          <div className='column-header'>
            <div className='column-title'>
              <div className='column-title-i'>

                <label onMouseEnter={(e) => showTooltip(e, 'Nome do Processo')} onMouseLeave={hideTooltip} >{props.columnData.name}</label>

                <MdInfo
                  className='column-title-icon-info'
                  onClick={(e) => {
                    e.stopPropagation(); // impede que o clique "suba"
                    setIsModalOpenInfoColumn(!isModalOpenInfoColumn);
                  }}
                />

              </div>


              <button onMouseEnter={(e) => showTooltip(e, 'Criar um Novo Card nesta Coluna')} onMouseLeave={hideTooltip} className='btn-add-new-card' onClick={handleAddCardClick}>+</button>
            </div>
            {/* <div className='column-info'>
              <label onMouseEnter={(e) => showTooltip(e, 'Quantidade de Cards nesta Coluna')} onMouseLeave={hideTooltip}  >{cardCount} Cards</label>
              <label onMouseEnter={(e) => showTooltip(e, 'Valor total de Custo de todos os Cards desta Coluna')} onMouseLeave={hideTooltip} >R$ {totalCostValue.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</label>
            </div> */}

            <div className='column-info'>
              <label
                onMouseEnter={(e) => showTooltip(e, 'Quantidade de Cards nesta Coluna')}
                onMouseLeave={hideTooltip}
              >
                {cardCount} Cards
              </label>

              {getAccessLevel('valor') && (
                <label
                  onMouseEnter={(e) => showTooltip(e, 'Valor total de Custo de todos os Cards desta Coluna')}
                  onMouseLeave={hideTooltip}
                >
                  R$ {totalCostValue.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                </label>
              )}
            </div>

          </div>
          <div className='column-body' ref={columnBodyRef}>

            {isModalOpenInfoColumn && (
              <div className='modal-info-coluna' style={{ whiteSpace: 'pre-wrap' }}>
                {props.columnData.description}
              </div>
            )}



            {!colData && !kanbanReady ? (
              <div className='column-spinner-container'>
                <div className='column-spinner' />
                <span className='column-spinner-text'>Carregando...</span>
              </div>
            ) : (
              <>
                {cardsToRender.map((card, index) => (
                  <Card key={card.card_id} cardData={card} index={index} />
                ))}
                {loadingMore && (
                  <div className='column-spinner-more'>
                    <div className='column-spinner-small' />
                  </div>
                )}
              </>
            )}
            {provided.placeholder}
          </div>
          <div className='column-footer'>{props.columnData.id}</div>
          {isModalOpen && <CreateCard columnId={props.columnData.id} onClose={handleCloseModal} />}




          {/* Tooltip com posição fixa */}
          {tooltip.visible && (
            <div
              style={{
                position: 'fixed', // Fixado à tela
                top: tooltip.y,
                left: tooltip.x,
                transform: 'translate(-50%, -100%)', // Centraliza horizontalmente e posiciona acima
                background: 'black',
                color: 'white',
                padding: '5px 10px',
                borderRadius: '5px',
                whiteSpace: 'nowrap',
                zIndex: 1000,
              }}
            >
              {tooltip.text}
            </div>
          )}




        </div>
      )}
    </Droppable>
  );
}

export default Column;
